//define a function
function hamburger__click() {
  if ($(".jsHamburger").length > 0) {
    $("header .jsHamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("is-menu-visible");
    });
    $(document).click(function (e) {
      var container = $("header");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parents("body").removeClass("is-menu-visible");
      }
    });
  }
}

//Image to SVG
function imgToSvg() {
  let convertImages = (query, callback) => {
    let images = document.querySelectorAll("img.svg");
    images.forEach((image) => {
      fetch(image.src)
        .then((res) => res.text())
        .then((data) => {
          let parser = new DOMParser();
          let svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");
          svg.setAttribute(
            "viewBox",
            "0 0 " +
              svg.getAttribute("width") +
              " " +
              svg.getAttribute("height"),
          );
          if (image.id) svg.id = image.id;
          if (image.className) svg.classList = image.classList;
          image.parentNode.replaceChild(svg, image);
        })
        .then(callback);
    });
  };
  convertImages("img");
}

// Header sticky on scroll
let lastScrollTop = 0;
const headerSticky = () => {
  if ($(".header").length > 0) {
    let scrollTop = $(window).scrollTop();
    const header = $(".header");

    if (scrollTop > 10) {
      header.addClass("is-sticky");
    } else {
      header.removeClass("is-sticky");
    }
    lastScrollTop = scrollTop;
  }
};

// keenslider navigation
function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createButton(className) {
    var div = document.createElement("button");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createButton("arrow arrow--left");
    arrowLeft.setAttribute("tabindex", "0");
    arrowLeft.setAttribute("aria-label", "previous slide");
    arrowLeft.setAttribute("role", "button");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowLeft.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowLeft.click();
      }
    });
    arrowRight = createButton("arrow arrow--right");
    arrowRight.setAttribute("tabindex", "0");
    arrowRight.setAttribute("aria-label", "next slide");
    arrowRight.setAttribute("role", "button");
    arrowRight.addEventListener("click", () => slider.next());
    arrowRight.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        arrowRight.click();
      }
    });

    innerWrapper.appendChild(arrowLeft);
    innerWrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("slider-wrapper");
    innerWrapper = createDiv("slider-navigation");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
    wrapper.appendChild(innerWrapper);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createButton("dot");
      dot.setAttribute("tabindex", "0");
      dot.setAttribute("aria-label", "navigate to slide " + (idx + 1));
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dot.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          dot.click();
        }
      });
      dots.appendChild(dot);
    });
    innerWrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    console.log(2);
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}
// keenslider init
function newsSlider() {
  if ($(".fhw.slider").length > 0) {
    var slider = new KeenSlider(
      "#newsSlider",
      {
        breakpoints: {
          "(min-width: 500px)": {
            slides: { perView: 2, spacing: 10 },
          },
          "(min-width: 991px)": {
            slides: { perView: 3.125, spacing: 32, origin: "center" },
          },
        },
        loop: true,
        slides: { perView: 1.12, spacing: 10 },
      },
      [navigation],
    );
  }
}

function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear();
    document.getElementById("year").innerHTML = year;
  }
}

//Cursor
function cursorClick() {
  $("a").each(function () {
    let href = $(this).attr("href");
    if (!href || href === "#" || href === "#0" || href === "#!") {
      $(this).addClass("is-unclickable");
    }
  });
}

function insightSlider() {
  if ($(".slider-gallery__serv").length > 0) {
    $(".wrapper-gallery").slick({
      lazyLoad: "ondemand",
      infinite: true,
      slidesToShow: 1.25,
      slidesToScroll: 1,
      // asNavFor: ".wrapper-gallery2",
      speed: 1200,
      cssEase: "cubic-bezier(0.75, 0, 0.125, 1)",
      arrows: true,
      prevArrow:
        '<button class="slick-prev" title="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" viewBox="0 0 25 22" fill="none"><g opacity="0.75"><path d="M24.8549 10.6907C24.8549 10.9542 24.7613 11.1761 24.5742 11.3563C24.387 11.5366 24.1616 11.6267 23.8982 11.6267H3.30706L11.6267 19.7176C11.807 19.8978 11.8971 20.1162 11.8971 20.3727C11.8971 20.6293 11.807 20.8476 11.6267 21.0279C11.5296 21.1111 11.4222 21.177 11.3043 21.2255C11.1865 21.274 11.0651 21.2983 10.9403 21.2983C10.8155 21.2983 10.6942 21.274 10.5763 21.2255C10.4585 21.177 10.358 21.1111 10.2748 21.0279L0.270388 11.3147C0.0901295 11.1345 0 10.9126 0 10.6491C0 10.3857 0.0901295 10.1638 0.270388 9.98358L10.2748 0.270388C10.455 0.0901299 10.6769 0 10.9403 0C11.2038 0 11.4326 0.0901299 11.6267 0.270388C11.807 0.450647 11.8971 0.669039 11.8971 0.92556C11.8971 1.18208 11.807 1.40047 11.6267 1.58073L3.22386 9.75479H23.8982C24.1616 9.75479 24.387 9.84838 24.5742 10.0356C24.7613 10.2228 24.8549 10.4412 24.8549 10.6907Z" fill="#262626"/></g></svg></button>',
      nextArrow:
        '<button class="slick-next" title="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" width="27" height="22" viewBox="0 0 27 22" fill="none"><g opacity="0.75"><path d="M26.6229 10.1098C26.6229 9.99884 26.5917 9.87058 26.5293 9.72498C26.4669 9.57939 26.401 9.46499 26.3317 9.3818L17.804 0.334181C17.6099 0.12619 17.3673 0.0152607 17.0761 0.00139618C16.7849 -0.0124702 16.5284 0.0845909 16.3065 0.292583C16.0985 0.472841 15.9911 0.718966 15.9841 1.03095C15.9772 1.34294 16.0708 1.59599 16.2649 1.79012L23.087 9.04901H1.06075C0.769567 9.04901 0.519978 9.15301 0.311987 9.361C0.103996 9.56899 0 9.81858 0 10.1098C0 10.4148 0.103996 10.6713 0.311987 10.8793C0.519978 11.0873 0.769567 11.1913 1.06075 11.1913H23.087L16.2649 18.4294C16.0708 18.6374 15.9772 18.8939 15.9841 19.199C15.9911 19.504 16.0985 19.7536 16.3065 19.9477C16.5145 20.1557 16.7676 20.2528 17.0657 20.2389C17.3638 20.2251 17.6099 20.1141 17.804 19.9061L26.3317 10.8585C26.4565 10.7337 26.5362 10.6089 26.5709 10.4841C26.6055 10.3594 26.6229 10.2346 26.6229 10.1098Z" fill="#262626"/></g></svg></button>',
      autoplay: true,
      autoplaySpeed: 6000,
      swipe: false,
    });

    // Move navigation buttons into existing slider-buttons-wrapper div
    function wrapSliderButtons() {
      const prevButton = $(".wrapper-gallery .slick-prev");
      const nextButton = $(".wrapper-gallery .slick-next");
      const existingWrapper = $(".slider-buttons-wrapper");

      if (prevButton.length && nextButton.length && existingWrapper.length) {
        // Check if slider-buttons div already exists
        let buttonsContainer = existingWrapper.find(".slider-buttons");

        if (!buttonsContainer.length) {
          // Create slider-buttons div inside the existing wrapper
          buttonsContainer = $('<div class="slider-buttons"></div>');
          existingWrapper.prepend(buttonsContainer);
        }

        // Move both buttons into the slider-buttons div
        buttonsContainer.append(prevButton);
        buttonsContainer.append(nextButton);
      }
    }

    // Wrap buttons after slider initialization
    $(".wrapper-gallery").on("init", function (event, slick) {
      wrapSliderButtons();
    });

    // Also wrap buttons if slider is already initialized
    setTimeout(function () {
      wrapSliderButtons();
    }, 100);
  }
}

// faq accordion
function accordion__toggle() {
  if ($(".faq__accordion .accordion__title button").length > 0) {
    var accordionButtons = $(".faq__accordion .accordion__title button");

    function checkOthers(elem) {
      for (var i = 0; i < accordionButtons.length; i++) {
        if (accordionButtons[i] != elem) {
          if ($(accordionButtons[i]).attr("aria-expanded") == "true") {
            $(accordionButtons[i]).attr("aria-expanded", "false");
            var content = $(accordionButtons[i]).attr("aria-controls");
            $("#" + content).attr("aria-hidden", "true");
            $("#" + content).slideUp();
            $(accordionButtons[i])
              .closest(".accordion__item")
              .removeClass("is-open");
          }
        }
      }
    }

    $(".faq__accordion .accordion__title button").on("click", function (e) {
      var $control = $(this);
      var accordionContent = $control.attr("aria-controls");
      checkOthers($control[0]);

      var isAriaExp = $control.attr("aria-expanded");
      var newAriaExp = isAriaExp == "false" ? "true" : "false";
      $control.attr("aria-expanded", newAriaExp);

      var isAriaHid = $("#" + accordionContent).attr("aria-hidden");
      if (isAriaHid == "true") {
        $("#" + accordionContent).attr("aria-hidden", "false");
        $("#" + accordionContent).slideDown();
        $control.closest(".accordion__item").addClass("is-open");
      } else {
        $("#" + accordionContent).attr("aria-hidden", "true");
        $("#" + accordionContent).slideUp();
        $control.closest(".accordion__item").removeClass("is-open");
      }
    });
  }
}

$(document).ready(function () {
  // imgToSvg();
  current__year();
  accordion__toggle();
});

$(window).on("load", function () {
  // hamburger__click();
  // newsSlider();
  cursorClick();
  insightSlider();
});
